import { Outlet } from "react-router-dom";
import Header from "./header";
import SideMenu from "./sidemenu";

const SIDEMENU_WIDTH = 257;
const HEADER_HEIGHT = 60;

const LayoutWithTopBar = () => {
  return (
    <div className="w-full h-screen overflow-x-hidden">
      <SideMenu />

      <div
        className="contentWidth flex flex-col h-screen"
        style={{
          marginLeft: `${SIDEMENU_WIDTH}px`,
          paddingTop: `${HEADER_HEIGHT}px`,
        }}
      >
        <div
          className="fixed top-0 right-0 bg-white"
          style={{
            left: `${SIDEMENU_WIDTH}px`,
            height: `${HEADER_HEIGHT}px`,
            zIndex: 11,
          }}
        >
          <Header />
        </div>

        <div className="flex-1 min-h-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutWithTopBar;
